import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-track-order',
  templateUrl: './track-order.component.html',
  styleUrls: ['./track-order.component.scss']
})
export class TrackOrderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/account/track-order/track-order.component.ts